module.exports = __webpack_public_path__ + "img/外圈.59778fec.png";